import { NavLink } from "react-router-dom";
import { navigationConfig } from "./navConfig";
import { NavItems } from "./NavItems";
import { SidebarFooter } from "./SidebarFooter";
import { BrandLogo } from "src/brand/BrandLogo";

export function Sidebar() {
	return (
		<aside
			aria-label="Main navigation"
			className="hidden xl:flex xl:w-[280px] xl:flex-col xl:fixed xl:inset-y-0 xl:left-0 xl:border-r xl:border-border xl:bg-background"
		>
			{/* Logo */}
			<div className="flex h-16 items-center px-6">
				<NavLink to="/admin" className="flex items-center">
					<BrandLogo className="h-6 w-auto" />
				</NavLink>
			</div>

			{/* Navigation */}
			<div className="flex-1 overflow-y-auto px-4 py-4">
				<NavItems items={navigationConfig} />
			</div>

			<SidebarFooter />
		</aside>
	);
}
